import React from 'react';
import { motion } from 'framer-motion';
import { Dribbble, Trophy } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';

const SporBasketbol: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <SEO
        title={t('games:sports.basketball.seoTitle')}
        description={t('games:sports.basketball.seoDescription')}
        url="/spor-bahisleri/basketbol"
      />
      <div className="min-h-screen bg-dark-900 pt-24 pb-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <div className="w-20 h-20 mx-auto mb-6 rounded-xl bg-gradient-to-r from-orange-500 to-amber-500 flex items-center justify-center">
              <Dribbble className="w-10 h-10 text-white" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              {t('games:sports.basketball.title')}
            </h1>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto">
              {t('games:sports.basketball.description')}
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-dark-800/50 backdrop-blur-sm rounded-2xl p-8 border border-dark-700 text-center"
          >
            <Trophy className="w-16 h-16 text-primary-400 mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-white mb-4">{t('games:comingSoon')}</h2>
            <p className="text-gray-400">
              {t('games:stayTuned')}
            </p>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default SporBasketbol;
